/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */


import { Query } from 'fierry/flux'

import Galaxy from 'shared/query/galaxy';


export default new Query([ Galaxy ], (galaxy) =>
{
  return galaxy ? galaxy.getCurrentUser() : null;
});
